import Apiaxios from '../api/endpoints.js'
import { OK, INTERNAL_SERVER_ERROR, ServerLoading } from '../util.js'

const state = {
  apiStatus: null,
  errorMessages: null,
  tasks: [],
  complete: false,
}

const getters = {
  
}

const mutations = {
  setApiStatus(state, status){
    state.apiStatus = status
  },
  setErrorMessages(state, messages){
    state.errorMessages = messages
  },
  setTasks(state, tasks){
    state.tasks.push(...tasks)
  },
  setComplete(state, complete){
    state.complete = complete
  },
  clearTasks(state){
    state.tasks = []
  }
}

const actions = {
  /**
  * 一般投稿取得
  */
  async getOfficialTask(context, data){

    context.commit('setApiStatus', null)
    context.commit('setErrorMessages', null)
    context.commit('loading/setLoadingStatus', { loading: true, loader: 'dots' }, { root: true } )

    //認証情報セット
    data.user = context.rootGetters['auth/user']
    data.token = context.rootGetters['auth/token']

    await Apiaxios.getOfficialTask(data).then(response => {
      if (response.status === OK) {
        context.commit('setApiStatus', true)
        if(response.data.length === 0){
          //表示するものがない場合
          context.commit('setComplete', true)
        }else{
          //表示するものがある場合
          context.commit('setTasks', response.data)
          context.commit('setComplete', false)
        }
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('setErrorMessages', "不明なエラーが発生しました。管理者へご連絡ください")
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true } )
    }).catch(function(error){
      console.log(error.response);
      context.commit('setApiStatus', false)
      context.commit('setComplete', true)

      context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
      }else{
        context.commit('setErrorMessages', error.response.data.errors)
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  },
  async officialCheck(context, data){

    context.commit('setApiStatus', null)
    context.commit('setErrorMessages', null)
    context.commit('loading/setLoadingStatus', { loading: true, loader: 'dots' }, { root: true } )

    //認証情報セット
    data.user = context.rootGetters['auth/user']
    data.token = context.rootGetters['auth/token']

    await Apiaxios.officialCheck(data).then(response => {
      if (response.status === OK) {
        context.commit('setApiStatus', true)
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('setErrorMessages', "不明なエラーが発生しました。管理者へご連絡ください")
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true } )
    }).catch(function(error){
      context.commit('setApiStatus', false)
      context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
      }else{
        context.commit('setErrorMessages', error.response.data.errors)
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  },
  clearHistory(context){
      //履歴を削除
      context.commit('clearTasks')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}